import { render, staticRenderFns } from "./CustomModal.vue?vue&type=template&id=eb81a778&scoped=true&"
import script from "./CustomModal.vue?vue&type=script&lang=js&"
export * from "./CustomModal.vue?vue&type=script&lang=js&"
import style0 from "./CustomModal.vue?vue&type=style&index=0&id=eb81a778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb81a778",
  null
  
)

export default component.exports